import SmbUnauthorizedContent from './components/SmbUnauthorizedContent';

const SmbUnauthorized = () => <SmbUnauthorizedContent />;

export default SmbUnauthorized;
